import * as ReactDOM from "react-dom";
import { ReactPortal } from "react";
import { PortalProps } from "components/flexComponents/SponsoredContentRenderer/portal/portal";

// A sponsored content slot (placeholder) is supposed to have the class 'SponsoredContentSlot' and
// an id equal to sci. The below code fetches an element based on that assumption and renders the
// child element of the portal inside the target element.
const Portal = ({ sponsoredContentId, children }: PortalProps): ReactPortal | null => {
  const container = document.querySelector(`[id^=${sponsoredContentId}].SponsoredContentSlot`);
  if (!container) {
    return null;
  }

  return ReactDOM.createPortal(children, container);
};

export default Portal;
